<template>
    <base-section>
        <template v-if="pageBusy">
            <spinner/>
        </template>
        <template v-else>
            <b-card-group deck>
                <consumer-card v-for="(consumer, index) in consumers"
                               :consumer="consumer"
                               :key="index"
                               @click="chooseConsumer(consumer)"
                />
            </b-card-group>

            <pagination :data="data"
                        :limit="10"
                        size="large"
                        align="center"
                        @pagination-change-page="getResults">
            </pagination>
        </template>
    </base-section>
</template>

<script>
import {mapActions}             from 'vuex';
import {getAllConsumersRequest} from "@/api/consumers";
import BaseSection              from "@/components/base/Section";
import ConsumerCard             from "@/components/consumer/ConsumerCard";
import Pagination               from 'laravel-vue-pagination'
import SpinnerComponent         from '@/components/base/SpinnerComponent'

export default {
    name:       'Users',
    components: {
        ConsumerCard,
        BaseSection,
        'pagination': Pagination,
        'spinner':    SpinnerComponent
    },
    data() {
        return {
            consumers: [],
            data:      {},
            pageBusy:  false
        };
    },
    async created() {
        await getAllConsumersRequest()
            .then(res => {
                this.consumers = res.data.data;
                this.data      = res.data;
            });
    },
    methods: {
        ...mapActions(['setSelectedConsumer']),
        chooseConsumer(consumer) {
            this.setSelectedConsumer(consumer);
            this.$router.push({name: "menu-items"});
        },
        async getResults(page = 1) {
            this.pageBusy = true
            await getAllConsumersRequest(page)
                .then(res => {
                    this.consumers = res.data.data;
                    this.data      = res.data;

                    this.pageBusy = false
                });
        }
    },
}
</script>
